<!--日记详情-->
<template>
  <div style="background:#EFEFEF;padding-bottom: 50px;">
    <!--pages/index/food/foodDetail/foodDetail.wxml-->
	<div class="activity-top-box">
		<div class="activity-title">{{diaryDetail.title}}冠顶饺，象小船，故又名“金山三船饺"！美餐，美味，美食！</div>
		<div class="detail-header">
			<div class="user-face">
			<!-- <img :src="userInfo.face" /> -->
				<img src="../../assets/images/activity/pic-logo1@2x.png" alt="" srcset="">
			</div>
		<div class="user-info">
			<div class="user-names">{{userInfo.name}}冠顶饺</div>
			<div class="look-info">{{diaryDetail.create_time | getTimeFormat}} 68阅读</div>
		</div>
		<div class="bottom-right" @click="getShare">分享</div>
		</div>
		<!-- <div class="activity-desc" v-html="diaryDetail.content"></div> -->
		<div class="activity-desc" >
			冠顶饺，象小船，故又名“金山三船饺"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺"！美餐，美味，美食！
		</div>
		<div class="activity-detail-bottom">
			<div class="activity-place-box">
				<img src="../../assets/images/activity/Shape@2x.png" alt="">
				<div class="activity-place">南京新街口</div>
			</div>
			<div class="release-time">{{1590045030 | getTimeFormat}}</div>
		</div>
		<div class="zan-box">
			<span class='zan-num'>90赞</span>
			<img class="user-zan-face" v-for="i in 4" :key="i" src="../../assets/images/activity/pic-logo1@2x.png" alt="">
		</div>
		<div class="interactive-box">
			<div class="interactive-item">
				<img src="../../assets/images/activity/icon-toupiao@2x.png" alt="">
				<div class="interactive-info">
					<p class="interactive-info-title">评选最佳观众投票</p>
					<p class="interactive-info-desc">啦啦操总决赛评选最佳观众有机会获取大奖哦~</p>
				</div>
				<div class="interactive-solid"></div>
				<div style="display: flex;justify-content:center;align-items: center;">
					<div class="interactive-btn">
						立即参与
					</div>
				</div>
			</div>
			<div class="interactive-item">
				<img src="../../assets/images/activity/icon-zhibo@2x.png" alt="">
				<div class="interactive-info">
					<p class="interactive-info-title">总决赛直播进行中</p>
					<p class="interactive-info-desc">点击这里进入专属直播通道~~</p>
				</div>
				<div class="interactive-solid"></div>
				<div style="display: flex;justify-content:center;align-items: center;">
					<div class="interactive-btn">
						立即参与
					</div>
				</div>
			</div> 
		</div>

		
	</div>
    <div class="comments-box">
		<div class="comments-box-title">评论</div>
		<div class="comments-list-box">
			<div class="comments-list" v-for="i in  3" :key="i">
				<div>
					<div class="user-face">
				<!-- <img :src="userInfo.face" /> -->
					<img src="../../assets/images/activity/pic-logo1@2x.png" alt="" srcset="">
				</div>
				<div class="user-info">
					<div class="user-names">{{userInfo.name}}冠顶饺</div>
					<div class="look-info">{{1590045030 | getTimeFormat}} </div>
				</div>
				</div>
				<div class="comments-content">好奥哈后哈哈哈</div>

			</div>
		</div>
	</div>

	<div class="send-comments">
		<van-field
		v-model="message"
		maxlength="50"
		:placeholder="commentsPlaceholder"
		show-word-limit
		/>
		<div class="zan-btn">
			<img src="../../assets/images/activity/icon-zan.png" alt="">
		</div>
	</div>
    <van-image-preview v-model="show" :images="images"></van-image-preview>
     
  </div>
</template>
<style scoped>
/* pages/index/food/foodDetail/foodDetail.wxss */
.zan-btn{width: 17px;height: 17px;margin-left: 13.5px;margin-right:10px;}
.zan-btn img{width: 17px;height: 17px;}
.send-comments >>> .van-cell{margin-left: 10px;padding:5px 8px;background: #EEEEEE;border-radius: 5px;}
.send-comments >>> .van-field__control{padding-right: 40px;}
.send-comments >>> .van-field__word-limit{position: absolute;top: 0 ;right: 0;}
.send-comments{
	width: 100%;
	height:1rem;border-top: 1px solid #f5f5f5;
	background:rgba(255,255,255,1);
	box-shadow:0px -1px 0px 0px rgba(0,0,0,0.12);
	position: fixed;
	bottom: 0;
	display: flex;justify-content:space-between;
	align-items: center;
}
.comments-content{
	font-size:14px;
	font-family:PingFangSC-Regular,PingFang SC;
	font-weight:400;
	color:rgba(0,0,0,1);
	line-height:20px;
	margin-left: 32px;
}
.comments-list-box{
	width:6.7rem; border-radius: 10px;background:#fff;
	 justify-content: space-between;margin-bottom: 14.5px;padding: 10px;
}
.comments-box{
	width: 7.1rem;
	
	margin: 10px auto;;
}
.comments-box-title{
	height:26px;
	font-size:19px;
	font-family:PingFangSC-Regular,PingFang SC;
	font-weight:400;
	color:rgba(102,102,102,1);
	line-height:26px;
	margin: 8px 0;
}


.interactive-box{width: 7.1rem;margin: 20px auto;margin-bottom: 10px;}
.interactive-item{width:6.7rem;height: 1.1rem;border-radius: 10px;background:#F3F3F3;display: flex;padding: 10px;justify-content: space-between;margin-bottom: 14.5px;}
.interactive-item img{width: 40px;height: 40px;margin-right: 0.18rem;}
.interactive-solid{width:1px;height:100%;background:rgba(0,0,0,0.08);margin: 0 0.16rem;}
.interactive-info{flex: 1;}
.interactive-btn{
	width:1.5rem;
	height:0.5rem;
	background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
	border-radius:5px;
	text-align: center;
	line-height: 0.5rem;  
	font-size:12px;
	font-family:PingFangSC-Regular,PingFang SC;
	font-weight:400;
	color:rgba(255,255,255,0.85);
	}
.interactive-info-title{
	 
	height:20px;
	font-size:14px;
	font-family:PingFangSC-Regular,PingFang SC;
	font-weight:400;
	color:rgba(0,0,0,1);
	line-height:20px;
	}
.interactive-info-desc{
	height:33px;
	font-size:12px;
	font-family:PingFangSC-Regular,PingFang SC;
	font-weight:400;
	color:rgba(153,153,153,1);
	line-height:16.5px;
	overflow: hidden;
	display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
	}


.zan-box{display: flex;flex-direction: row-reverse;padding: 0 10px;}
.user-zan-face{width: 22px;height: 22px;border-radius: 22px;margin-right: 4px;}
.zan-num{padding:1px 5px;background:rgba(231,231,231,1);border-radius:22px;
	font-size:11px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(102,102,102,1);line-height: 20px;}
.activity-top-box{padding-bottom: 10px;border-radius: 0 0 10px 10px ;background: #fff;}
.activity-detail-bottom{padding-left: 10px;}
.activity-place-box{
	display: flex;
	align-items: center;
	 
}
.release-time{
	font-size: 12px;
  	font-family: PingFangSC-Regular, PingFang SC;
  	font-weight: 400;
  	color: rgba(190, 190, 190, 1);
	margin-left: 5px;}
.activity-place-box img{width: 15px;height: 20px;}
.activity-place{
	font-size: 12px;
  	font-family: PingFangSC-Regular, PingFang SC;
  	font-weight: 400;
  	color: rgba(190, 190, 190, 1);
	margin-left: 5px;
}
.comment-box {
  background: #fff;
}
.comment-desc {
  padding: 0 0.3rem;
  margin-bottom: 0.1rem;
}
.comment-item-list {
  display: flex;
  overflow-x: scroll;
}
.item-desc {
  margin-right: 0.2rem;
}
.item-desc img {
  height: 2rem;
}
.comment-img-list {
  padding: 0 0.2rem;
  overflow-x: scroll;
}

.comment-img {
  display: block;
  height: 80px;
  width: 100px;
  margin-right: 0.1rem;
  float: left;
}
.comment-header {
  padding: 10px 10px;
  display: flex;justify-content:center;align-items: center;
  background: #fff;
}
.comment-num {
  text-align: center;
}
.comment {
  padding: 10px 10px;
  display: flex;
  align-items: center;
  background: #fff;
  margin-top: 10px;
}
.comment-btn {
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #ccc;
  border: 1px solid #cccccc;
  border-radius: 10px;
  width: 60%;
}
.comment-user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
  background: #ccc; 
}
.comment-user-face img {
  width: 32px;
  height: 32px;
}
.activity-title {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  padding: 10px 10px;
  background: #fff;
}
.comments-list{
  background: #fff;
  display: flex;
  flex-direction: column;
  margin-bottom: 28px;
}
.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}
.user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-face img {
  height: 32px;
  width: 32px;
}
.user-info {
  margin-left: 5px;
  float: left;
}
.user-info view {
  height: 50px;
  line-height: 50px;
}
.user-names {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1)
}
.look-info {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  line-height: 17px;
}
.bottom-right {
  float: right;
  height: 50px;
  background: url(https://static.dierqudao.com/images/mishijia/icon-mishijia-bshare.png)
    no-repeat left center;
  padding: 0 25px;
  background-size: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 50px;
}
.activity-desc {
  padding: 10px 10px; 
  background: #fff;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  overflow: hidden;
}


</style>

<script>
import Vue from "vue"; 
import { ImagePreview,Field } from "vant";
Vue.use(ImagePreview).use(Field);
export default {
  name: "ActivityDetail",
  components: {
    ImagePreview,
  },
  data: function() {
    return {
	  message:'',
	  commentsPlaceholder:'已有76条回复，参与互动',
	 
      diaryId: 0,
      diaryDetail: {},
      userInfo: {},
      recomGoodsLsit: [],
      materialList: [],
      images: [],
      show: false,
      loginShow:false,
      shareShow:false, 
      diaryData:{},
      shareData:{}
    };
  },

  mounted() {
    document.title = "详情";
    this.diaryId = this.$route.query.id || 10;
    this.getDiaryDetail();
  },
  destroyed() {},
  methods: {
    getShare(){
      let that = this;
        // 判断是否登陆
        that.$api.get('/api/user/userPage', {}, (res) => {
           this.shareShow=true
        }, (res) => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true
          } else {
            Toast(res.msg)
          }
        });
        this.diaryData=this.diaryDetail
        this.shareData=this.diaryDetail.share
        console.log(goods)
    },
    shareCancel() {
        console.log('-------取消分享-------')
        this.shareShow = false;
      },
      loginSuccess(res) {
        console.log('-------登录成功--------', res);
        let that = this;
        that.loginShow = false;
        // that.showSkuPicker = true 
      },
      loginCancel() {
        console.log('-------取消登录--------');
        this.loginShow = false;
      },
    getDiaryDetail() {
      let that = this;
      this.$api.get("/api/fooddiary/diaryDetail", { id: this.diaryId }, res => {
        that.diaryDetail = res.data;
        that.recomGoodsLsit = res.data.goods_list;
        that.userInfo = res.data.user_info;
        that.materialList = res.data.material_list;
        console.log(that.images);
      });
    },
    toGoodsDetail(goods) {
      console.log(goods);
      this.$router.push({
        path: "/goodsDetail",
        query: {
          id: goods.id
        }
      });
    },
    toMaterialAdd() {
      this.$router.push({
        path: "/diarymaterialadd",
        query: {
          id: this.diaryId
        }
      });
    },
    //查看大图
    previewImages(i, index) {
      console.log(i, index);
      this.startPosition = parseInt(index) + 1;
      this.images = [];
      this.materialList[i].pics.map((item, i) => {
        this.images.push(item.url);
      });
      this.show = true;
    },
    
  },
  filters: {
      getTimeFormat(valueTime) {
        console.log(valueTime,parseInt())
        
        if (valueTime) {
          // let newData = Date.parse(new Date() + '')
          // let diffTime = Math.abs(newData - valueTime)
          let diffTime = Math.abs(
            new Date().getTime() - new Date(valueTime*1000).getTime()
          );
          if (diffTime > 7 * 24 * 3600 * 1000) {
            let date = new Date(valueTime);
            // let y = date.getFullYear()
            let m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let minute = date.getMinutes();
            let second = date.getSeconds();
            console.log(second);
            minute = minute < 10 ? "1" + minute : minute;
            second = second < 10 ? "0" + second : second;
            return m + "-" + d + " " + h + ":" + minute;
          } else if (
            diffTime < 7 * 24 * 3600 * 1000 &&
            diffTime > 24 * 3600 * 1000
          ) {
            // //注释("一周之内");
            // var time = newData - diffTime;
            let dayNum = Math.floor(diffTime / (24 * 60 * 60 * 1000));
            return dayNum + "天前";
          } else if (diffTime < 24 * 3600 * 1000 && diffTime > 3600 * 1000) {
            // //注释("一天之内");
            // var time = newData - diffTime;
            let dayNum = Math.floor(diffTime / (60 * 60 * 1000));
            return dayNum + "小时前";
          } else if (diffTime < 3600 * 1000 && diffTime > 0) {
            // //注释("一小时之内");
            // var time = newData - diffTime;
            let dayNum = Math.floor(diffTime / (60 * 1000));
            return dayNum + "分钟前";
          }
        }
      }
    }
};
</script>


// WEBPACK FOOTER //
// ActivityDetail.vue?7acfe246